import { loadImage } from '@forest/shared'
import { getLocalizedMessage } from '~/lib/l10n'
import { m } from '~/paraglide/messages'
import type { GrantedContent } from '~/resources/claim-reward'
import type { Item } from './store'

const COIN_BG = '#F6E085'
const COIN_GRADIENT = 'linear-gradient(to right, #DC9907, #FED345)'
const GEM_BG = '#7DDFEB'
const GEM_GRADIENT = 'linear-gradient(to right, #4C57B3, #45C6FE)'
const TREE_BG = '#F8E69B'

async function titleFor(g: GrantedContent): Promise<string> {
  switch (g.type) {
    case 'coin':
      return `${m.coin()} x${g.value}`
    case 'gem':
      return `${m.time_crystal()} x${g.value}`
    default:
      return (await getLocalizedMessage(g.title_key)) ?? ''
  }
}

async function buildItem(g: GrantedContent): Promise<Item> {
  const title = await titleFor(g)
  const label = g.type === 'coin' || g.type === 'gem' ? `x${g.value}` : ''

  // Preload the icon so the reward screen renders it immediately, but never
  // let a failed image block the claim — the reward is already granted.
  if (g.icon_image_url) await loadImage(g.icon_image_url).catch(() => {})

  if (g.type === 'coin') {
    return {
      title,
      icon: g.icon_image_url,
      label,
      bgAnimType: 1,
      resultBgColor: COIN_BG,
      resultTextGradient: COIN_GRADIENT,
      type: g.type,
      value: g.value,
      isBigPrize: false,
    }
  }
  if (g.type === 'gem') {
    return {
      title,
      icon: g.icon_image_url,
      label,
      bgAnimType: 2,
      resultBgColor: GEM_BG,
      resultTextGradient: GEM_GRADIENT,
      type: g.type,
      value: g.value,
      isBigPrize: false,
    }
  }
  return {
    title,
    icon: g.icon_image_url,
    label,
    bgAnimType: 3,
    resultBgColor: TREE_BG,
    type: g.type,
    value: g.value,
    isBigPrize: false,
  }
}

export async function convertGrantedContentsToRewardItems(
  contents: GrantedContent[],
): Promise<Item[]> {
  return Promise.all(contents.map(buildItem))
}
